const achievements = [
  {
    id: 1,
    year: '2025',
    title: 'IASAS Singapore Tournament',
    description: 'Represented ISM at the international IASAS badminton tournament in Singapore',
    type: 'International',
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
      </svg>
    ),
  },
  {
    id: 2,
    year: '2025',
    title: 'Singapore Regional Tournament',
    description: 'Competed in competitive badminton tournament against regional opponents',
    type: 'Regional',
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    id: 3,
    year: '2024-2025',
    title: 'ISM Varsity Team Member',
    description: 'Active member of the ISM varsity badminton team, training and competing regularly',
    type: 'Team',
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
        <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
      </svg>
    ),
  },
  {
    id: 4,
    year: '2025',
    title: 'Tournament Experience',
    description: 'Gained valuable competitive experience across multiple badminton tournaments',
    type: 'Experience',
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
];

const AchievementsSection = () => {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <h2
            className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold tracking-tight"
            style={{ color: 'var(--color-heading)' }}
          >
            Achievements & Milestones
          </h2>
          <p
            className="text-base sm:text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Tournament participation and competitive badminton experience
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div
            className="absolute left-8 top-0 bottom-0 w-0.5 hidden md:block"
            style={{ backgroundColor: 'var(--color-border-light)' }}
          ></div>

          {/* Achievement Cards */}
          <div className="space-y-8">
            {achievements.map((achievement, index) => (
              <div
                key={achievement.id}
                className="relative md:pl-24"
              >
                {/* Timeline dot */}
                <div
                  className="absolute left-6 w-5 h-5 rounded-full border-4 hidden md:block"
                  style={{
                    backgroundColor: 'var(--color-accent-5)',
                    borderColor: 'var(--color-body-bg)',
                  }}
                ></div>

                {/* Card */}
                <div
                  className="p-5 sm:p-6 rounded-xl shadow-card transition-all duration-300 hover:shadow-card-hover"
                  style={{
                    backgroundColor: 'var(--color-card-bg)',
                    borderColor: 'var(--color-card-border)',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                  }}
                >
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                    <div className="flex items-start gap-3 sm:gap-4 flex-1">
                      {/* Icon */}
                      <div
                        className="flex-shrink-0 inline-flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-lg"
                        style={{
                          backgroundColor: 'var(--color-accent-2)',
                          color: 'var(--color-accent-7)',
                        }}
                      >
                        {achievement.icon}
                      </div>

                      {/* Content */}
                      <div className="space-y-2 flex-1">
                        <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                          <h3
                            className="text-lg sm:text-xl font-semibold"
                            style={{ color: 'var(--color-heading)' }}
                          >
                            {achievement.title}
                          </h3>
                          <span
                            className="px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-semibold"
                            style={{
                              backgroundColor: 'var(--color-accent-2)',
                              color: 'var(--color-accent-8)',
                            }}
                          >
                            {achievement.type}
                          </span>
                        </div>
                        <p
                          className="text-xs sm:text-sm leading-relaxed"
                          style={{ color: 'var(--color-muted)' }}
                        >
                          {achievement.description}
                        </p>
                      </div>
                    </div>

                    {/* Year Badge */}
                    <div
                      className="flex-shrink-0 text-xl sm:text-2xl font-bold text-center min-w-[70px] sm:min-w-[80px]"
                      style={{ color: 'var(--color-accent-6)' }}
                    >
                      {achievement.year}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div
          className="mt-12 sm:mt-16 p-6 sm:p-8 rounded-2xl text-center space-y-3 sm:space-y-4"
          style={{
            backgroundColor: 'var(--color-accent-1)',
            borderColor: 'var(--color-accent-3)',
            borderWidth: '1px',
            borderStyle: 'solid',
          }}
        >
          <h3
            className="text-xl sm:text-2xl font-bold"
            style={{ color: 'var(--color-heading)' }}
          >
            Committed to Excellence
          </h3>
          <p
            className="text-base sm:text-lg max-w-2xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Continuously improving through dedicated training, competitive matches, and teamwork with ISM varsity badminton
          </p>
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
